/**
 * Compact "spinner + visible progress text" — deliberately NOT the shared
 * Spinner.tsx: that one's `.spinner-container` is 220px tall (sized to
 * replace a chart while its data loads), way oversized for a couple of
 * lines of text in a dialog — it was making the whole dialog balloon in
 * height for no reason. Also fixes a real accessibility gap the old
 * `<Spinner label={...}>` had: Spinner only puts `label` in `aria-label`,
 * never renders it as visible text — the "X of Y windows" count was
 * invisible to sighted users, screen-reader-only. Shared by
 * AemetFetchDialog.tsx and AemetProvenanceDialog.tsx (both show "X of Y
 * AEMET requests" progress, one live right after a fetch, one for a later
 * retry).
 */
export function InlineProgress({ text }: { text: string }) {
  return (
    <div className="aemet-inline-progress" role="status">
      <div className="spinner" aria-hidden="true" />
      <p>{text}</p>
    </div>
  );
}
